import Head from 'next/head'
import NextLink from 'next/link'

import { Box, Card, Container, Typography } from '@mui/material'

import { ForgotPasswordForm } from '../../components/authentication/forgot-password-form'
import { GuestGuard } from '../../components/authentication/guest-guard'
import { Logo } from '../../components/logo'

import type { NextPage } from 'next'
const ForgotPassword: NextPage = () => {
  return (
    <>
      <Head>
        <title>Forgot Password | Realty Portal</title>
      </Head>
      <Box
        component="main"
        sx={{
          backgroundColor: 'background.default',
          display: 'flex',
          flexDirection: 'column',
          minHeight: '100vh',
        }}
      >
        <Container
          maxWidth="sm"
          sx={{
            py: {
              xs: '60px',
              md: '120px',
            },
          }}
        >
          <Card elevation={16} sx={{ p: 4 }}>
            <Box
              sx={{
                flexGrow: 1,
              }}
            >
              <div>
                <Box sx={{ py: 3, textAlign: 'center' }}>
                  <NextLink href="/" passHref>
                    <a>
                      <Logo
                        sx={{
                          width: 100,
                        }}
                      />
                    </a>
                  </NextLink>
                </Box>
              </div>
              <Typography variant="h6">Forgot Password?</Typography>
              <Box mb={2} />
              <ForgotPasswordForm />
              <Box mb={2} />
              <NextLink href="/auth/login">
                <a>Go to Login</a>
              </NextLink>
            </Box>
          </Card>
        </Container>
      </Box>
    </>
  )
}

ForgotPassword.getLayout = page => <GuestGuard>{page}</GuestGuard>

export default ForgotPassword
